module.exports = __webpack_public_path__ + "img/housing.4953bde1.png";